import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IThreat } from '../../../../shared/models/threat';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../../shared/helpers/icons';

@Component({
  selector: 'threat-details',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './threat-details.component.html',
  styleUrl: './threat-details.component.css'
})
export class ThreatDetailsComponent {
  icons = Icons

  @Input() threatDetails: IThreat | null = null;

  @Output() onClose = new EventEmitter<void>;

  closeModal(): void {
    this.onClose.emit();
  }
}
